import { put, takeEvery, all, takeLeading } from 'redux-saga/effects';
import * as constants from '../constants/announcement';
import * as announcementPageActions from '../actions/announcementPage';
import { Log } from 'ng2-logger';
import { Common } from '../../core/common';
import { AnnouncementPageService } from '../../api/announcement-service';
import { Notification } from '../../components/notification/main';
import * as coreActions from '../actions/core';
import Translator from '../../core/i18n';
import { MessageState } from '../../models/components/selectedAnnouncement';
import { CacheService } from '../../core/cacheService';
import { IActionRequestDate } from '../../models/core/action-request';
import { param } from 'jquery';
import { BackgroundService } from '../../api/background-service';

const T = Translator.create();
const _logger = Log.create('announcementPage Saga');
const _cacheService = new CacheService();
const announcementPageService = new AnnouncementPageService();

const _backgroundService = new BackgroundService();

//#region "Add Assignment Activity Saga"
function* setAddAnnouncement(params: any): any {
    let isError = false;
    let errorList: any;
    try {
        const requestReturn = yield announcementPageService
            .RequestAddAnnouncementAsync(params.announcementData)
            .then((response: Response) => {
                return response;
            })
            .then((response: Response) => {
                if (response.status !== 200) {
                    isError = true;
                }
                return response.json();
            })
            .then((responseData: any) => {
                if (isError) {
                    errorList = responseData;
                }
                return responseData;
            });

        if (isError) {
            errorList
                ? Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                })
                : yield put(coreActions.newNotification(T.t('r_announcement_add_error_message'), '', '', 'topRight', 'error'));
        }

        if (!isError) {
            yield put(
                coreActions.newNotification(
                    T.t(
                        !params.announcementData.isUpdate
                            ? 'r_announcement_add_successful_message'
                            : 'r_announcement_update_successful_message'
                    ),
                    '',
                    '',
                    'topRight',
                    'success'
                )
            );

            const announcementBackgroundData = {
                announcementId: params.announcementData.announcementId ? params.announcementData.announcementId : requestReturn,
                isSendMail: params.announcementData.isEmail,
                hostAddress: params.announcementData.hostAddress,
            }

            if (params.announcementData.isEmail) {
                _backgroundService
                    .RequestGetAnnouncementEmailAsync(announcementBackgroundData)
                    .then((responseData: Response) => {
                        return responseData;
                    })
                    .then((responseData: Response) => {
                        if (responseData.status !== 200) {
                            isError = true;
                        }
                        return responseData;
                    })
                    .then(response => {
                        if (isError) {
                            errorList = response;
                        }
                    });
            }

            const redirectPageParams: any = {
                announcementId: params.announcementData.announcementId ? params.announcementData.announcementId : requestReturn,
            };
            params.callback(redirectPageParams);
        } else {
            yield put(coreActions.setSpinner('addAnnouncementLoading', 'set'));
        }
    } catch (error: any) {
        yield put(
            coreActions.newNotification(
                T.t(params.forumData.isUpdate ? 'r_announcement_add_error_message' : 'r_announcement_update_error_message'),
                '',
                '',
                'topRight',
                'error'
            )
        );
        yield put(coreActions.setSpinner('addAnnouncementLoading', 'set'));
    }
}

//#region "Announcement Saga"
function* setAnnouncementsData(params: any): any {
    let isError = false;
    let errorList: any;
    const cacheData: IActionRequestDate = { firstRequestDate: new Date(), actionName: params.type };

    if (params.lastAnnouncementId && params.isHomePageAnnouncement || params.isHompageBox) {
        if (!_cacheService.CheckCache(cacheData)) {
            _cacheService.AddOrUpdateActionRequest(cacheData);
            try {
                const pageData = yield announcementPageService
                    .RequestGetAnnouncementListAsync(params)
                    .then((response: Response) => {
                        return response;
                    })
                    .then((response: Response) => {
                        if (response.status !== 200) {
                            isError = true;
                        }
                        return response.json();
                    })
                    .then((responseData: any) => {
                        if (isError) {
                            errorList = responseData;
                        }
                        return responseData;
                    });

                if (isError) {
                    errorList
                        ? Object.keys(errorList).forEach((key: any) => {
                            Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                        })
                        : yield put(coreActions.newNotification(T.t('r_get_announcement_list_error_message'), '', '', 'topRight', 'error'));
                }

                if (!isError) {
                    if (pageData.length <= 0 && (params.lastAnnouncementId !== null || params.lastAnnouncementId !== '')) {
                        params.lastAnnouncementId = '';
                        const pageData2 = yield announcementPageService
                            .RequestGetAnnouncementListAsync(params)
                            .then((response: Response) => {
                                return response;
                            })
                            .then((response: Response) => {
                                if (response.status !== 200) {
                                    isError = true;
                                }
                                return response.json();
                            })
                            .then((responseData: any) => {
                                if (isError) {
                                    errorList = responseData;
                                }
                                return responseData;
                            });

                        if (isError) {
                            errorList
                                ? Object.keys(errorList).forEach((key: any) => {
                                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                                })
                                : yield put(coreActions.newNotification(T.t('r_get_announcement_list_error_message'), '', '', 'topRight', 'error'));
                        }
                        if (!isError) {
                            yield put(announcementPageActions.setAnnouncementsAction(pageData2, true, '4', params.spinnerId, 'set', params.take, params.skip, params.isHomePageAnnouncement));
                            if (params.callback) params.callback();
                        }
                    } else {
                        yield put(announcementPageActions.setAnnouncementsAction(pageData, true, '4', params.spinnerId, 'set', params.take, params.skip, params.isHomePageAnnouncement));
                        if (params.callback) params.callback();
                    }
                }
            } catch (error: any) {
                yield put(announcementPageActions.setAnnouncementsAction([], true, '4', params.spinnerId, 'set', params.take, params.skip, params.isHomePageAnnouncement));
            }
        } else {
            // yield put(coreActions.setSpinner(params.spinnerId, 'set'));
            try {
                const pageData = yield announcementPageService
                    .RequestGetAnnouncementListAsync(params)
                    .then((response: Response) => {
                        return response;
                    })
                    .then((response: Response) => {
                        if (response.status !== 200) {
                            isError = true;
                        }
                        return response.json();
                    })
                    .then((responseData: any) => {
                        if (isError) {
                            errorList = responseData;
                        }
                        return responseData;
                    });

                if (isError) {
                    errorList
                        ? Object.keys(errorList).forEach((key: any) => {
                            Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                        })
                        : yield put(coreActions.newNotification(T.t('r_get_announcement_list_error_message'), '', '', 'topRight', 'error'));
                }

                if (!isError) {
                    yield put(announcementPageActions.setAnnouncementsAction(pageData, true, '4', params.spinnerId, 'set', params.take, params.skip, params.isHomePageAnnouncement, params.lastAnnouncementId));
                    if (params.callback) params.callback();
                }
            } catch (error: any) {
                yield put(announcementPageActions.setAnnouncementsAction([], true, '4', params.spinnerId, 'set', params.take, params.skip, params.isHomePageAnnouncement));
            }
        }
    } else {
        try {
            const pageData = yield announcementPageService
                .RequestGetAnnouncementListAsync(params)
                .then((response: Response) => {
                    return response;
                })
                .then((response: Response) => {
                    if (response.status !== 200) {
                        isError = true;
                    }
                    return response.json();
                })
                .then((responseData: any) => {
                    if (isError) {
                        errorList = responseData;
                    }
                    return responseData;
                });

            if (isError) {
                errorList
                    ? Object.keys(errorList).forEach((key: any) => {
                        Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                    })
                    : yield put(coreActions.newNotification(T.t('r_get_announcement_list_error_message'), '', '', 'topRight', 'error'));
            }

            if (!isError) {
                yield put(announcementPageActions.setAnnouncementsAction(pageData, true, '4', params.spinnerId, 'set', params.take, params.skip, params.isHomePageAnnouncement));
                if (params.callback) params.callback();
            }
        } catch (error: any) {
            yield put(announcementPageActions.setAnnouncementsAction([], true, '4', params.spinnerId, 'set', params.take, params.skip, params.isHomePageAnnouncement));
        }
    }



}

export function* watchGetAnnouncementsData() {
    yield takeEvery(constants.actions.GET_ANNOUNCEMENT_LIST, setAnnouncementsData);
    return null;
}

function* setSelectedAnnouncementsData(params: any): any {
    let isError = false;
    let errorList: any;
    try {
        const pageData = yield announcementPageService
            .RequestGetSelectedAnnouncementAsync(params.announcementId)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            })
            .then(response => {
                if (isError) {
                    errorList = response;
                } else {
                    return response;
                }
            });

        if (isError) {
            errorList
                ? Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                })
                : Notification.setNotification('error', T.t('r_get_selected_announcement_error_message'), 'topRight');
        }

        if (!isError) {
            yield put(announcementPageActions.setSelectedAnnouncementAction(pageData, true, params.spinnerId, 'set', params.announcementIndex));
            if (params.callback) {
                params.callback();
            }
        }
    } catch (error: any) {
        Notification.setNotification('error', T.t('r_get_selected_announcement_error_message') + error, 'topRight');
    }
}

function* getUnreadAnnouncementCount(params: any): any {
    let isError = false;
    let errorList: any;
    try {
        const pageData = yield announcementPageService
            .RequestGetUnreadAnnouncementCountAsync(params)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            })
            .then(response => {
                if (isError) {
                    errorList = response;
                } else {
                    return response;
                }
            });

        if (isError) {
            errorList
                ? Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                })
                : Notification.setNotification('error', T.t('r_get_unread_announcement_count_error_message'), 'topRight');
        }

        if (!isError) {
            yield put(announcementPageActions.setUnreadAnnouncementCountAction(pageData, params.spinnerId));
            if (params.callback) {
                params.callback();
            }
        }
    } catch (error: any) {
        Notification.setNotification('error', T.t('r_get_unread_announcement_count_error_message') + error, 'topRight');
    }
}

function* getAnnouncementData(params: any): any {
    let isError = false;
    let errorList: any;
    try {
        const pageData = yield announcementPageService
            .RequestGetSelectedAnnouncementAsync(params.announcementId)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            })
            .then(response => {
                if (isError) {
                    errorList = response;
                } else {
                    return response;
                }
            });

        if (isError) {
            errorList
                ? Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                })
                : Notification.setNotification('error', T.t('r_get_selected_announcement_error_message'), 'topRight');
        }

        if (!isError) {
            yield put(announcementPageActions.setAnnouncementData(pageData));
            params.callback('Edit');
        }
    } catch (error: any) {
        Notification.setNotification('error', T.t('r_get_selected_announcement_error_message') + error, 'topRight');
    }
}

function* getDeleteAnnouncement(params: any): any {
    let isError = false;
    let errorList: any;
    try {
        const pageData = yield announcementPageService
            .RequestDeleteAnnouncementAsync(params.announcementData)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            })
            .then(response => {
                if (isError) {
                    errorList = response;
                } else {
                    return response;
                }
            });

        if (isError) {
            errorList
                ? Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                })
                : Notification.setNotification('error', T.t('r_'), 'topRight');
        }

        if (!isError) {
            Notification.setNotification('success', T.t('r_delete_announcement_success'), 'topRight');
            params.callback('Delete');
        }
    } catch (error: any) {
        Notification.setNotification('error', T.t('r_gen_delete_error_message') + error, 'topRight');
    }
}

function* setCourseAnnouncementsData(params: any): any {
    try {
        const pageData = yield announcementPageService
            .RequestCourseAnnouncementsAsync(params.coursePageClassId, params.coursePageActivityId, MessageState.Sent, params.take, params.skip)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((data: any | null) => {
                if (!data) {
                    return null;
                } else {
                    return data;
                }
            });
        yield put(announcementPageActions.setCourseAnnouncementsAction(pageData, true, params.spinnerId, 'set', '', params.take, params.skip));
        if (params.callback) params.callback();
    } catch (error: any) {
        yield put(announcementPageActions.setCourseAnnouncementsAction([], true));
    }
}

function* GetReadAnnouncement(params: any): any {
    let isError = false;
    let errorList: any;
    try {
        const myYield = announcementPageService.RequestReadAnnouncementAsync().then((responseData: Response) => {
            return responseData;
        }).then((responseData: Response) => {
            if (responseData.status !== 200) {
                isError = true;
            }
            return responseData.json();
        }).then((response) => {
            if (isError) {
                errorList = response;
            } else {
                return response;
            }
        });
        const pageData = yield myYield;
        if (isError) {
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        } else {

        }
    } catch (error: any) {
        yield put(coreActions.setSpinner(params.spinnerId, 'set'));
    }
}

export function* watchGetReadNMessages() {
    yield takeEvery(constants.actions.GET_READ_ANNOUNCEMENT, GetReadAnnouncement);
    return null;
}

export function* watchGetAddAnnouncementData() {
    yield takeEvery(constants.actions.ADD_ANNOUNCEMENT, setAddAnnouncement);
    return null;
}

export function* watchGetSelectedAnnouncementData() {
    yield takeLeading(constants.actions.GET_SELECTED_ANNOUNCEMENT, setSelectedAnnouncementsData);
    return null;
}

export function* watchGetAnnouncementData() {
    yield takeEvery(constants.actions.GET_ANNOUNCEMENT_DATA, getAnnouncementData);
    return null;
}

export function* watchGetUnreadAnnouncementCount() {
    yield takeEvery(constants.actions.GET_UNREAD_ANNOUNCEMENT_COUNT, getUnreadAnnouncementCount);
    return null;
}

export function* watchGetDeleteAnnouncement() {
    yield takeEvery(constants.actions.GET_DELETE_ANNOUNCEMENT, getDeleteAnnouncement);
    return null;
}

export function* watchSetCourseAnnouncementsData() {
    yield takeEvery(constants.actions.GET_COURSE_ANNOUNCEMENT, setCourseAnnouncementsData);
    return null;
}

//#endregion "Announcement Saga"

export function* AnnouncementSagas() {
    yield all([watchGetAnnouncementsData(), watchGetSelectedAnnouncementData(), watchGetAddAnnouncementData(), watchGetAnnouncementData(), watchGetDeleteAnnouncement(), watchSetCourseAnnouncementsData(), watchGetUnreadAnnouncementCount(), watchGetReadNMessages()]);
}
